import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.to,
    disabled: _ctx.disable,
    class: _normalizeClass(["btn btn-md transition-colors hover:preset-filled-primary-500 hover:brightness-100 focus:preset-filled-primary-500 focus:cursor-default active:preset-filled-primary-700 active:brightness-100 disabled:bg-primary-950 disabled:text-opacity-50 disabled:brightness-75 disabled:cursor-not-allowed py-5", _ctx.borderStyle])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}